import React from 'react';
import { ScreenController } from 'src/feature-app';
import { GTI50LeadForm } from 'src/forms/FormsAdhoc/GTI50Leads2025';
import { GTI50LeadFormTelefono } from 'src/forms/FormsAdhoc/GTI50Leads2025/GTI50LeadFormTelefono';

export function GTI50LeadTrigger(): JSX.Element {
	return (
		<ScreenController
			selectedJourney={<GTI50LeadForm />}
			closeLayerCallback={close}
			handleAreYouSureLayer={() => null}
			notALayer={true}
			formType="inPage"
		/>
	);
}

export function GTI50LeadTelefonoTrigger(): JSX.Element {
	return (
		<ScreenController
			selectedJourney={<GTI50LeadFormTelefono />}
			closeLayerCallback={close}
			handleAreYouSureLayer={() => null}
			notALayer={true}
			formType="inPage"
		/>
	);
}
